export default () => {
  const switchers = document.querySelectorAll('.js-language-switcher')

  if (!switchers) {
    return
  }

  ;[...switchers].forEach(switcher => {
    let toggler = switcher.querySelector('.js-language-toggler')
    const dropdown = switcher.querySelector('.js-language-toggler--dropdown')
    toggler.addEventListener('mouseover', () => {
      switcher.classList.add('active')
      toggler.classList.add('active')

      dropdown.addEventListener('mouseleave', e => {
        switcher.classList.remove('active')
        toggler.classList.remove('active')
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/LanguageSwitcher.js